<template>
  <div>
    <list
      ref="refProfileList"
      sort-by="PerfilId"
      :refetch-records="fetchProfiles"
      refetch-records-name="perfiles"
      :actions="actions"
      key-field="perfilId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteProfile"
      :filters.sync="filters"
    />>
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refProfileList = ref(null)
    /* Services */
    const {
      fetchProfiles,
      deleteProfile,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.profile.columns.name'),
        key: 'nombre',
      },
      {
        label: i18n.t('humanResources.profile.columns.gender'),
        key: 'genero.nombre',
      },
      {
        label: i18n.t('humanResources.profile.columns.minimumAge'),
        key: 'edadMinima',
      },
      {
        label: i18n.t('humanResources.profile.columns.maxiumAge'),
        key: 'edadMaxima',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'Perfil',
        routeName: 'apps-human-resources-profile-edit',
        params: ['perfilId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'Perfil',
        params: ['perfilId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-profile-add',
        label: i18n.t('Routes.ProfileAdd'),
        aclAction: 'create',
        aclResource: 'Perfil',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refProfileList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchProfiles,
      deleteProfile,
    }
  },
}
</script>
